import '../loader.css';

const Loader = (props) => {
  const { loading } = props;
  return (
    <>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader" />
        </div>
      )}
    </>
  );
};

export default Loader;
